<template>
  <div>
    <!-- Modal -->
    <div id="edit-modal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header d-flex align-items-center">
            <h2 class="text-center">Edit Category</h2>
            <button type="button" class="close p-0 m-0" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <form @submit="submit" class="product-form">
              <div class="row">
                <div class="col-lg-12">
                  <label for="">
                    <span>Name:</span>
                    <input type="text" v-model="category.name" class="form-control">
                  </label>
                  <label for="" class="checkbox-icon">
                    <span class="text-left">Enabled:</span>
                    <label class="checkbox-container mr-5">
                      <input v-model="category.is_enabled" type="checkbox">
                      <span class="checkmark"></span>
                    </label>

                    <span class="text-left">Menu Top:</span>
                    <label class="checkbox-container">
                      <input v-model="category.is_menu_top" type="checkbox">
                      <span class="checkmark"></span>
                    </label>
                  </label>
                  <label for="">
                    <span>Sort #:</span>
                    <input type="number" v-model="category.sort_no" class="form-control">
                  </label>
                  <label for>
                    <span>Thumbnail</span>
                    <section class="form-control replace" :class="{'d-none': isObject(category.thumbnail)}">
                      <input type="button" class="replace-btn" data-id="thumbnail-update" value="Replace File">
                      <span>{{category.thumbnail}}</span>
                    </section>
                    <input :class="{'d-none': !isObject(category.thumbnail)}" @change="onFileChange($event, 'thumbnail')" type="file" id="thumbnail-update" class="form-control" />
                  </label>
                  <div class="col-lg-12">
                    <div class="thumbnail-display"></div>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 d-flex justify-content-center mt-3">
                <button type="submit" :disabled="this.$store.getters.apiStatus == 'loading'" class="btn btn-success">
                  <div v-if="this.$store.getters.apiStatus != 'loading'">Update</div>
                  <div v-else class="loader"><Loader></Loader></div>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import Category from '@/models/Category'
export default{
  name: 'EditCategoryModal',
  props: ['category'],
  data () {
    return {}
  },
  coumputed: {
    category () {
      console.log(this.category)
      return new Category(this.category)
    }
  },
  mounted () {
    $('.thumbnail-display').click(function () {
      $('#thumbnail').click()
    })
    $('.thumbnail-display').css('background-image', 'url("' + this.category.thumbnailUrl + '")')
    $(document).on('change', '#thumbnail', function () {
      if (event.target.files.length) { $('.thumbnail-display').css('background-image', 'url(' + window.URL.createObjectURL(event.target.files[0]) + ')') } else { $('.thumbnail-display').css('background-image', 'none') }
    })
    $('.modal').on('click', '.replace-btn', function () {
      var id = $(this).attr('data-id')
      $('#' + id).click()
    })
  },
  methods: {
    submit (event) {
      event.preventDefault()
      var category = new Category(this.category).getFormData()
      this.$store.dispatch('editCategory', category)
        .then(() => {
          this.$toast.success('Category Updated Successfully')
          // eslint-disable-next-line no-undef
          $('#edit-modal .close').click()
          this.$parent.fetchAllCategories()
          $('.thumbnail-display').css('background-image', 'url("")')
        })
        .catch((err) => this.$toast.error(err.response.data.message))
    },
    onFileChange (e, index) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.category[index] = null
        index = null
      } else { this.category[index] = files[0] }
      console.log(this.category)
    },
    isObject (val) {
      if (this.toEdit && (val === 'null' || val === '')) { return true }
      return (typeof val === 'object')
    }
  }
}
</script>

<style scoped>
.thumbnail-display {
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/EditCategoryModal.vue